import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import ErrorPage from "../common/ErrorPage";

class ZipnosisError extends React.Component {
    componentDidMount() {
        const { errorMessage, userTags } = this.props;
        logUI('MBHWeb.Evisits.Start.Zipnosis.Failure', new Date(), Tools.getURLPath(), errorMessage, 'eVisits', 'Zipnosis' + userTags());
    }

    onUpdateClick = () => {
        const { errorMessage, userTags } = this.props;
        logUI('MBHWeb.Evisits.Start.Zipnosis.Redirect.Error.Update.Clicked', new Date(), Tools.getURLPath(), errorMessage, 'eVisits', 'Zipnosis' + userTags());
    }

    render() {
        const { title, errorMessageName, technicalHelpDeskNumber, technicalHelpDeskHours } = this.props;
        let { errorMessage } = this.props;
        let detailMessge = '';
        let helpDeskLink = <a href={"tel:" + technicalHelpDeskNumber} className="phone-link">{technicalHelpDeskNumber}</a>;
        let updateDemographicsMsg = (
            <div>
                You can update it <Link to={{ pathname: "/demographics" }} onClick={this.onUpdateClick}>here.</Link>{' '}
                For technical assistance, call the MyBSWHealth technical help desk {technicalHelpDeskHours} at {helpDeskLink}.
            </div>);
        let callHelpDeskMsg = <div>For technical assistance, call the MyBSWHealth technical help desk {technicalHelpDeskHours} at {helpDeskLink}.</div>;

        switch (errorMessageName) {
            case 'zipnosisInvalidZipCodeMessage':
            case 'zipnosisNoEmailMessage':
            case 'zipnosisEmailTakenMessage':
            case 'zipnosisInvalidPhoneMessage':
                detailMessge = updateDemographicsMsg;
                break;
            case 'zipnosisNoGenderMessage':
            case 'zipnosisInvalidTokenDependentMessage':
            case 'zipnosisFailedToAuthenticateMessage':
            case 'zipnosisActivatedPatientMessage':
            case 'zipnosisAccountLockedMessage':
            case 'zipnosisNoEPID':
            case 'zipnosisDefaultMsg':
                detailMessge = callHelpDeskMsg;
                break;
            default:
                errorMessage = '';
                detailMessge = callHelpDeskMsg;
                break;
        }

        return (
            <ErrorPage heading={"We were unable to begin the " + title + "."}>
                {/*We are currently having an issue initiating {title === 'eVisit' ? 'an eVisit' : 'a screening'}.*/}
                {/*' '*/}{errorMessage}{' '}{detailMessge}
            </ErrorPage>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        technicalHelpDeskHours: state.session.serverData ? state.session.serverData.technicalHelpDeskHours:""
    };
};

export default connect(mapStateToProps)(ZipnosisError);